export const backgroundColorUtilityVariants = () => ({
    /**
     * @deprecated
     */
    "neutral-inverse-1": "sui-u-background-neutral-inverse-1",
    /**
     * @deprecated
     */
    "neutral-inverse-2": "sui-u-background-neutral-inverse-2",
    /**
     * @deprecated
     */
    "neutral-inverse-3": "sui-u-background-neutral-inverse-3",
    /**
     * @deprecated
     */
    "purple-1": "sui-u-background-purple-1",
    /**
     * @deprecated
     */
    "purple-2": "sui-u-background-purple-2",
    /**
     * @deprecated
     */
    "purple-3": "sui-u-background-purple-3",
    /**
     * @deprecated
     */
    "purple-inverse-1": "sui-u-background-purple-inverse-1",
    /**
     * @deprecated
     */
    "purple-inverse-2": "sui-u-background-purple-inverse-2",
    /**
     * @deprecated
     */
    "cyan-1": "sui-u-background-cyan-1",
    /**
     * @deprecated
     */
    "red-1": "sui-u-background-red-1",
    /**
     * @deprecated
     */
    "red-inverse-1": "sui-u-background-red-inverse-1",
    /**
     * @deprecated
     */
    "indigo-1": "sui-u-background-indigo-1",
    /**
     * @deprecated
     */
    "indigo-2": "sui-u-background-indigo-2",
    /**
     * @deprecated
     */
    "indigo-inverse-1": "sui-u-background-indigo-inverse-1",
    /**
     * @deprecated
     */
    "indigo-inverse-2": "sui-u-background-indigo-inverse-2",
    /**
     * @deprecated
     */
    "magenta-inverse-1": "sui-u-background-magenta-inverse-1",
    /**
     * @deprecated
     */
    "green-1": "sui-u-background-green-1",
    /**
     * @deprecated
     */
    "green-inverse-1": "sui-u-background-green-inverse-1",
    /**
     * @deprecated
     */
    "yellow-1": "sui-u-background-yellow-1",
});

export const textColorUtilityVariants = () => ({
    /**
     * @deprecated
     */
    "purple-1": "sui-u-color-purple-1",
    /**
     * @deprecated
     */
    "cyan-1": "sui-u-color-cyan-1",
    /**
     * @deprecated
     */
    "red-1": "sui-u-color-red-1",
    /**
     * @deprecated
     */
    "green-1": "sui-u-color-green-1",
    /**
     * @deprecated
     */
    "indigo-1": "sui-u-color-indigo-1",
    /**
     * @deprecated
     */
    "yellow-1": "sui-u-color-yellow-1",
});
